import { Badge, Tooltip, TooltipContent, TooltipTrigger } from '@repo/shared-client/components/ui'
import { cn } from '@repo/shared-client/lib/utils'
import { useAuth } from '@web/src/hooks/use-auth'
import { useTranslation } from '@web/src/lib/intl/react'
import { type ComponentProps, forwardRef } from 'react'
import { enumToString } from 'src/lib/utilsClient'
import type { ReviewEnum } from 'types/graphql'

interface SFMediaReviewStatusProps extends ComponentProps<typeof Badge> {
  reviewStatus: ReviewEnum
}

const SFMediaReviewStatus = forwardRef<HTMLSpanElement, SFMediaReviewStatusProps>((props, forwardedRef) => {
  const { reviewStatus, className, variant: variantProp, size = 'sm', ...rest } = props
  const { hasPermission } = useAuth()
  const { t } = useTranslation()

  let displayReview = false

  if (reviewStatus && reviewStatus !== 'ACCEPTED' && hasPermission('media:review')) {
    displayReview = true
  }

  const variant = variantProp ?? (reviewStatus === 'REJECTED' ? 'destructive' : 'outline')

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Badge
            className={cn(
              'absolute bottom-1 left-1 shadow-sm',
              reviewStatus === 'UNREVIEWED',
              reviewStatus === 'NEEDS_REVIEW' &&
                'border-amber-500/40 bg-amber-500/15 text-amber-950 dark:border-amber-400/40 dark:bg-amber-400 dark:text-black',
              !displayReview && 'hidden',
              className
            )}
            ref={forwardedRef}
            size={size}
            variant={variant}
            {...rest}
          />
        }
      >
        {enumToString(reviewStatus)}
      </TooltipTrigger>
      <TooltipContent>
        {t('Admins need to review and approve this image before it can be seen by other users.')}
      </TooltipContent>
    </Tooltip>
  )
})

SFMediaReviewStatus.displayName = 'SFMediaReviewStatus'

export default SFMediaReviewStatus
